<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-ml-' + id"
    data-toggle='collapse'
    :data-target="'#collapse-ml-' + id"
    :aria-controls="'collapse-ml-' + id"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_ML", 1) }}
  .collapse.show(
    :aria-labelledby="'heading-ml-' + id"
    :id="'collapse-ml-' + id"
  )
    .card-body.p-0
      .market-card-content
        .normal(v-if="mode == 0 || mode == 1")
          .normal-title {{ $t("ui.full_time") }}
          .normal-odd-area
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 H
              template(v-if="details['ml'] && details['ml'][0] && details['ml'][0][5] != 0 && details['ml'][0][5] != ''")
                OddsItem(:odds="details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
              template(v-else)
                OddsDisabled
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 A
              template(v-if="details['ml'] && details['ml'][0] && details['ml'][0][7] != 0 && details['ml'][0][7] != ''")
                OddsItem(:odds="details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
              template(v-else)
                OddsDisabled
        .normal(v-if="mode == 0 || mode == 2")
          .normal-title {{ $t("ui.half_time") }}
          .normal-odd-area
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 H
              template(v-if="details['mlh'] && details['mlh'][0] && details['mlh'][0][5] != 0 && details['mlh'][0][5] != ''")
                OddsItem(:odds="details['mlh'][0]" idx=5 :typ="oddsType" dataType="2")
              template(v-else)
                OddsDisabled
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 A
              template(v-if="details['mlh'] && details['mlh'][0] && details['mlh'][0][7] != 0 && details['mlh'][0][7] != ''")
                OddsItem(:odds="details['mlh'][0]" idx=7 :typ="oddsType" dataType="2")
              template(v-else)
                OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  }
}
</script>